// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"f50efbb2","488":"33b7884a"}[chunkId] + ".chunk.js";
};